exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{height:6.6rem;background-color:#005fd4;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end;margin-bottom:-.3rem}.aofl-tab-logo{-webkit-align-self:center;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;width:15rem;margin-left:3rem}.abcmouse-tab-logo{width:17rem;margin-left:3rem}.academy-link{display:-webkit-flex;display:-ms-flexbox;display:flex}.academy-tab-logo{-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end;width:22.6rem;margin-left:1rem}@media only screen and (max-width:568px){.aofl-tab-logo{margin-left:2.3rem;width:5rem}#academy-logo{top:.2rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/home-tabs/home-tabs.css
// module id = uPd3
// module chunks = 0